import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const PointIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.9128 6.60781C15.9128 10.073 13.237 12.9177 9.84634 13.1908C12.1647 12.0092 13.7633 9.59634 13.7633 6.81628C13.7633 6.434 13.7335 6.06166 13.6739 5.69429C13.6193 5.33686 13.5349 4.98937 13.4257 4.65169C13.3363 4.3688 13.232 4.09573 13.1079 3.82763C12.6958 2.93399 12.1051 2.14471 11.3753 1.49433C10.6505 0.843945 9.78671 0.337554 8.84351 0.0248471C8.99731 0.0149085 9.15124 0 9.30517 0C10.8888 0 12.3483 0.560933 13.4852 1.49433C14.2548 2.12483 14.8753 2.91908 15.2973 3.82763C15.4215 4.09076 15.5307 4.3688 15.615 4.65169C15.7242 4.9844 15.7986 5.33686 15.8483 5.69429C15.8931 5.99221 15.9128 6.29498 15.9128 6.60781Z"
        fill="#0BA95E"
      />
      <path
        d="M13.2176 6.81773C13.2176 10.4619 10.2532 13.4264 6.60899 13.4264C6.25144 13.4264 5.9007 13.3979 5.55839 13.3429C5.16111 13.2791 4.77506 13.18 4.40466 13.0483C4.11652 12.946 3.83762 12.8244 3.56955 12.6852C2.86567 12.3192 2.23563 11.8304 1.70793 11.2469C0.646894 10.0743 0 8.52005 0 6.81773C0 3.17392 2.96479 0.209106 6.60899 0.209106C8.3113 0.209106 9.86513 0.855999 11.0377 1.91704C11.6212 2.44435 12.11 3.07439 12.4764 3.77828C12.6156 4.04634 12.7372 4.32525 12.8392 4.61339C12.9712 4.98418 13.0703 5.36943 13.1341 5.76713C13.1891 6.10943 13.2176 6.46018 13.2176 6.81773Z"
        fill="#45D88E"
      />
      <path
        d="M15.2971 3.82775H13.1077C12.6956 2.93411 12.1049 2.14483 11.3751 1.49445H13.485C14.2546 2.12495 14.8751 2.9192 15.2971 3.82775Z"
        fill="#45D88E"
      />
      <path
        d="M15.8484 5.69421H13.674C13.6193 5.33678 13.535 4.98929 13.4258 4.65161H15.6151C15.7243 4.98432 15.7987 5.33678 15.8484 5.69421Z"
        fill="#45D88E"
      />
      <path
        d="M6.60889 11.6836C9.29622 11.6836 11.4747 9.50507 11.4747 6.81772C11.4747 4.13037 9.29622 1.95184 6.60889 1.95184C3.92156 1.95184 1.74304 4.13037 1.74304 6.81772C1.74304 9.50507 3.92156 11.6836 6.60889 11.6836Z"
        fill="#0BA95E"
      />
      <path
        d="M9.72408 6.9778C8.32837 7.55246 7.34358 8.53766 6.76892 9.93338C6.70913 10.0779 6.50808 10.0779 6.44868 9.93338C6.17259 9.26321 5.80219 8.68774 5.33668 8.20658C4.83305 7.6861 4.21866 7.27637 3.49311 6.9778C3.34865 6.91841 3.34865 6.71736 3.49311 6.65756C4.88883 6.0829 5.87402 5.0977 6.44868 3.70197C6.50808 3.55751 6.70913 3.55751 6.76892 3.70197C7.06748 4.42753 7.47721 5.04193 7.99769 5.54556C8.47845 6.01106 9.05391 6.38146 9.72408 6.65756C9.86895 6.71736 9.86895 6.91841 9.72408 6.9778Z"
        fill="white"
      />
    </svg>
  )
})

PointIcon.displayName = 'PointIcon'
